import { z } from 'zod';

// Admin serialization of a PointExpiryPeriod (PointExpiryPeriodBlueprint). Field
// keys arrive camelized by OliveBranch because the query sends `Key-Inflection:
// camel`. Defensive `.catch` fields keep one malformed value from blanking the
// whole admin view (mirrors the external-recognition schemas' resilience posture).
export const PointExpiryPeriodStatus = z.enum(['deleted', 'upcoming', 'active', 'completed']);
export type PointExpiryPeriodStatus = z.infer<typeof PointExpiryPeriodStatus>;

export const PointExpiryPeriod = z.object({
	id: z.string(),
	// `startAt` is nullable: a period may begin immediately (no scheduled start).
	startAt: z.string().nullable().catch(null),
	endAt: z.string().catch(''),
	warningAt: z.string().catch(''),
	status: PointExpiryPeriodStatus.catch('completed'),
	deletedAt: z.string().nullable().optional().catch(null),
	// Present only on SHOW: the number of point balances the period will expire.
	impactedPointsCount: z.number().optional().catch(undefined),
});
export type PointExpiryPeriod = z.infer<typeof PointExpiryPeriod>;
